const loadMoreParams = typeof lm_params_formations != "undefined" ? lm_params_formations : lm_params;
let loadMore = {
    url: lm_params.ajaxurl,
    fetchUrl: '',
    posts: JSON.parse(loadMoreParams.posts),
    currentPage: parseInt(loadMoreParams.current_page),
    maxPage: parseInt(loadMoreParams.max_page),
    btn: '',
    shape: '',

    init: function () {
        
        loadMore.btn = document.getElementById('loadmore-btn');
        loadMore.shape = document.getElementById('loadmore-shape');
        loadMore.nomore = document.getElementById('loadmore-nomore');
        let classic = document.getElementById('classic-pagination');
        if(classic && !( document.body.classList.contains('paged') || document.body.classList.contains('tax-categorie-financements') || document.body.classList.contains('post-type-archive-financements') ) ) {
            classic.classList.add('hidden');
        }
        if(loadMore.btn) {
            loadMore.fetchUrl = loadMore.btn.classList.contains('load-formations') ? loadMore.url + '&paged=' : (loadMore.url.match(/[?]/) ? loadMore.url + 'page/' : loadMore.url + 'page/');
            if (loadMore.maxPage == loadMore.currentPage) {
                loadMore.btn.style.display = 'none';
            }
            loadMore.btn.addEventListener('click', loadMore.get);
        }
        
    },

    get: function () {

        loadMore.animate();
        loadMore.currentPage = loadMoreParams.max_page > loadMore.currentPage ? loadMore.currentPage + 1 : loadMore.currentPage;
        loadMore.posts.paged = loadMore.currentPage;
        let payload = {
            'query': loadMore.posts
        };
        fetch(loadMore.url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'Cache-Control': 'no-cache',
                },
                body: 'action=loadmore&data=' + JSON.stringify(payload)
            }).then((resp) => resp.text())
            .then(async function (data) {
                loadMore.animate();
                const container = document.getElementById('postslist');
                if(data) {
                    container.insertAdjacentHTML( 'beforeend', data );
                    for(let item of container.querySelectorAll('.ajax-post')) {
                        await loadMore.revealer(item);
                    }
                }
                
                if (loadMore.maxPage == loadMore.currentPage) {
                    loadMore.btn.style.display = 'none';
                }

            }).catch((resp) => {
                console.log('error', resp);
                loadMore.animate();
            });
    },

    delay: function() {
        return new Promise(resolve => { setTimeout(resolve, 300) });
    },

    revealer: async function(item) {
        await loadMore.delay();
        item.classList.add('ajax-post-revealed');
    },

    animate: function () {
        loadMore.shape.classList.toggle('right-shape-animate');
    },
}
const timer = ms => new Promise(res => setTimeout(res, ms));
document.addEventListener('DOMContentLoaded', loadMore.init);